/**
 * 
 * @author Tim
 * @date 2024-01-05
 */

const $qLoading = {
	show(title = '加载中') {
		uni.showLoading({
			title,
		});
	},

	hide() {
		uni.hideLoading();
	},
};

const $qModal = {
	cancel(text, title = '提示') {
		uni.showModal({
			title,
			content: text,
			showCancel: false,
			buttonText: '关闭',
		});
	},
	confirm(text, title = '提示', confirmCallback) {
		uni.showModal({
			title,
			content: text,
			success: function(res) {
				if (res.confirm) {
					if (typeof confirmCallback === 'function') {
						confirmCallback();
					}
				}
			},
		});
	},
};

const $qToast = {
	show(text, icon = 'none') {
		uni.showToast({
			title: text,
			icon,
			duration: 2000,
		});
	},
	hide() {
		uni.hideToast();
	},
};

const $qSet = {
	barTitle(title) {
		uni.setNavigationBarTitle({
			title: title
		});
	},
};



const $qData = {
	formatTimestampToDate(timestamp) {
		// 从时间戳创建一个Date对象
		let date = new Date(timestamp * 1000); // 乘以1000转换成毫秒

		// 获取年、月、日
		let year = date.getFullYear();
		let month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始，需要+1；使用padStart补0
		let day = date.getDate().toString().padStart(2, '0');

		// 格式化日期
		let formattedDate = `${year}-${month}-${day}`;

		return formattedDate;
	},
	formatCreatedAt(createdAtString, includeTime = false) {
		// 检查输入的日期字符串是否有效
		if (!createdAtString || isNaN(Date.parse(createdAtString))) {
			return ''; // 如果无效，返回空字符串或者您认为合适的默认值
		}

		var createdAtDate = new Date(createdAtString);
		var formattedDate = createdAtDate.toISOString().split('T')[0];
		if (includeTime) {
			formattedDate += ' ' +
				createdAtDate.getHours().toString().padStart(2, '0') + ':' +
				createdAtDate.getMinutes().toString().padStart(2, '0');
		}
		return formattedDate;
	},
};

// 支付宝登录工具
const $qAuth = {
	// 支付宝登录
	alipayLogin() {
		return new Promise((resolve, reject) => {



























































			

			reject(new Error('当前环境不支持支付宝登录'));

		});
	},
	
	// 微信公众号登录
	wechatMPLogin() {
		return new Promise((resolve, reject) => {

			// H5环境中的微信公众号登录需要使用微信JS-SDK
			if (typeof wx !== 'undefined' && wx.config) {
				// 如果已经加载了微信JS-SDK，使用微信网页授权
				this.getWechatMPAuthCode()
					.then(authData => {
						resolve(authData);
					})
					.catch(err => {
						reject(err);
					});
			} else {
				// 如果没有JS-SDK，引导用户进行微信授权
				this.redirectToWechatMPAuth();
			}

			








































			





		});
	},
	
	// 获取微信公众号授权码
	getWechatMPAuthCode() {
		return new Promise((resolve, reject) => {

			// 从URL中获取授权码
			const urlParams = new URLSearchParams(window.location.search);
			const code = urlParams.get('code');
			const state = urlParams.get('state');
			
			if (code) {
				// 如果URL中有code，说明是从微信授权页面返回的
				resolve({
					code: code,
					state: state || '',
					nickname: '',
					gender: 0
				});
			} else {
				// 如果没有code，需要跳转到微信授权页面
				reject(new Error('需要微信授权'));
			}

			



		});
	},
	
	// 跳转到微信公众号授权页面
	redirectToWechatMPAuth() {

		// 这里需要根据实际的微信公众号配置来构建授权URL
		// 一般需要从后端获取授权URL
		const currentUrl = encodeURIComponent(window.location.href);
		const authUrl = `/api/wechat/auth?redirect_uri=${currentUrl}`;
		
		// 跳转到授权页面
		window.location.href = authUrl;

	}
};

const $q = {
	loading: $qLoading,
	modal: $qModal,
	toast: $qToast,
	set: $qSet,
	data: $qData,
	auth: $qAuth,
};


export default $q;